import { Post as Base } from './Post';
import { Preview } from './Preview';

// eslint-disable-next-line functional/immutable-data -- Assign Post.Preview Component
export const Post = Object.assign(Base, { Preview });
